import type { BusinessObjectIdType, BusinessObjectTypeType } from '../types.js'

type Validator = (text: string) => string | null
const validCharactersValidator: Validator = (text) =>
	text.match(/^[a-zA-Z0-9_]+$/)
		? null
		: 'Can only contain letters A-Z, numbers and _'
const lowerCaseStartValidator: Validator = (text) =>
	text.match(/^[a-z]/) ? null : 'Must start with a lower-case letter'
const upperCaseStartValidator: Validator = (text) =>
	text.match(/^[A-Z]/) ? null : 'Must start with an upper-case letter'

export class IdentifierValidator {
	static isBoIdValid(
		boId: BusinessObjectIdType,
		moduleId: string,
		boType: BusinessObjectTypeType,
	) {
		const validators = [validCharactersValidator]
		switch (boType) {
			case 'Label': {
				break
			}

			default: {
				validators.push(upperCaseStartValidator)
			}
		}
		if (boType !== 'Module') {
			validators.push((text) =>
				text === moduleId ? 'Cannot be the same as the module id' : null,
			)
		}

		return this.validate(boId, validators)
	}

	static isEntitySubsetName(subsetName: BusinessObjectIdType) {
		return this.validate(subsetName, [
			validCharactersValidator,
			upperCaseStartValidator,
		])
	}

	static isEntityPropertyNameValid(propertyName: string) {
		return this.validate(propertyName, [
			validCharactersValidator,
			lowerCaseStartValidator,
		])
	}

	static isStaticEntityEntryIdValid(entryId: BusinessObjectIdType) {
		return this.validate(entryId, [
			validCharactersValidator,
			upperCaseStartValidator,
		])
	}

	static isVariableNameValid(variableName: string) {
		return this.validate(variableName, [validCharactersValidator])
	}

	private static validate(text: string, validators: Validator[]) {
		for (const validator of validators) {
			const result = validator(text)
			if (result) return result
		}
		return null
	}
}
